module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a2-7-009829d88fd00dcb4bb5740e51d909ce.jpg";